import React from "react";
import { Bell } from "lucide-react";
import './css/NotificationBell.css';

const NotificationBell = ({ count = 0, onClick }) => {
  return (
    <button className="notif-btn" onClick={onClick}>
      <Bell className="notif-icon" />

      {count > 0 && (
        <span className="notif-badge">
          {count > 9 ? "9+" : count}
        </span>
      )}
    </button>
  );
};

export default NotificationBell;